{
  "reports": {
    "incentiveReport": "Rapport d'incitatifs",
    "incentiveReportDescription": "Montants d'incitatifs finalisés par équipement et période de déclaration, avec les prix des crédits et des CER.",
    "equipmentReport": "Rapport d'équipement",
    "equipmentReportDescription": "Chaque équipement pour chaque période de déclaration où il était actif, avec les données d'utilisation déclarées.",
    "facilityReport": "Rapport d'installations",
    "facilityReportDescription": "Détails des installations avec programme, service public et personnes-ressources.",
    "userReport": "Rapport d'utilisateurs",
    "userReportDescription": "Comptes d'utilisateurs par client avec rôle, statut et dernière connexion.",
    "includedColumns": "Colonnes incluses",
    "columnCountLabel": "Nombre de colonnes :",
    "filterClientName": "Nom du client",
    "filterReportingPeriod": "Période de déclaration",
    "filterStatus": "Statut",
    "filterProgram": "Programme",
    "filterFacilityAddress": "Adresse de l'installation",
    "filterCity": "Ville",
    "filterStateProvince": "État / Province",
    "filterEquipmentCategory": "Catégorie d'équipement",
    "filterEquipmentType": "Type d'équipement",
    "filterManufacturer": "Fabricant",
    "filterMetered": "Mesuré",
    "filterFseUtility": "Service public FSE",
    "filterContactName": "Nom de la personne-ressource",
    "filterUserRole": "Rôle d'utilisateur",
    "optionAll": "Tous",
    "optionActive": "Actif",
    "optionInactive": "Inactif",
    "optionYes": "Oui",
    "optionNo": "Non",
    "generateReport": "GÉNÉRER LE RAPPORT",
    "generatingReport": "GÉNÉRATION...",
    "generatingHint": "Les rapports volumineux peuvent prendre quelques minutes. Gardez cette page ouverte jusqu'au début du téléchargement.",
    "noFilterHint": "Laissez un filtre vide pour tout inclure."
  }
}
